<template>
    <div class="footer">
        <div class="footer-content">

            <div class="footer-top">
                <img class="footer-img" src="../../static/default/img/NTFusion_logo.png" alt="">
                <ul>
                    <li>
                        <a>{{langContentData.footer.info1}}</a>
                    </li>
                    <li>
                        <a>{{langContentData.footer.info2}}</a>
                    </li>
                    <li>
                        <a>{{langContentData.footer.info3}}</a>
                    </li>
                    <li>
                        <a>{{langContentData.footer.info4}}</a>
                    </li>
                    <li>
                        <a href="http://www.ntfusion.com/privacy-policy.html" target="_blank" style="margin-left: 5px;text-wrap: nowrap;">{{langContentData.footer.info5}}</a>
                    </li>
                </ul>

            </div>


            <p class="fcm">{{langContentData.footer.info6}}</p>
            <p>{{langContentData.footer.info7}}</p>
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">{{langContentData.footer.info8}}</a>
                |
                <a>{{langContentData.footer.info9}}</a>
                <br>
            </p>
            <p>{{langContentData.footer.info10}}</p>
            <p>{{langContentData.footer.info11}}</p>
            <p>{{langContentData.footer.info12}}</p>
        </div>
    </div>
</template>

<script>
    import langCn from '../data/lang_cn'

    export default {
        data () {
            return {
                langContentData: langCn,
                contents: ''
            }
        },
    }
</script>
<style lang="less">
    .footer {
        padding: 40px 0;
        font-size: 13px;
        color: #ffffff;
        background-color: #282f3e;
        text-align: left;

        .footer-content {
            margin: 0 auto;
            width: 1000px;
            position: relative;

            .footer-top {
                overflow: unset!important;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;

                .footer-img {
                    width: 150px;
                    height: 50px;
                }
            }

            .fcm:before {
                display: block;
                margin: 18px 0 16px;
                height: 1px;
                content: "";
                background-color: rgba(83,97,128,.9);
            }

            ul {
                display: inline-block;
                li {
                    display: inline-block;
                    width: 60px;
                    height: 15px;
                    line-height: 15px;
                    a {
                        color: #0089bc;
                        text-decoration: underline;
                    }
                }
                li + li {
                    /*border-left: 2px solid #ffffff;*/
                }
            }
            p {
                margin: 10px 0 20px;

                a {
                    color: #ffffff;
                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue